<template>
  <v-dialog
      :value="value"
      width="550"
      style="z-index: 201"
      @click:outside="close"
  >
    <v-card>
      <v-card-title>PDFアップロード</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="auto" style="width: 120px;">
            <v-btn outlined @click="addPDF" color="primary">PDF選択</v-btn>
          </v-col>
          <v-col cols>
            <span>{{ pdfName }}</span>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <div class="mt-3">
          <span class="text-subtitle-1 font-weight-bold">
            ページ名入力
          </span>
        </div>
        <div class="mt-3">
          <v-text-field
              v-model="pageName"
              label="ページ名*"
              dense
              hide-details="auto"
              outlined
              :rules="[v => (!!v && !!v.trim()) || 'ページ名を記入してください。']"
          ></v-text-field>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click="close">キャンセル</v-btn>
        <v-btn @click="uploadPdf" color="primary" :disabled="!uploadable">アップロード</v-btn>
      </v-card-actions>
    </v-card>

    <!-- Invisible File Input -->
    <input
        ref="pdfUploader"
        class="d-none"
        type="file"
        accept="application/pdf"
        @change="readPDF"
        @click="$refs.pdfUploader.value = null"
    />
  </v-dialog>
</template>

<script>
import {store} from "@/store";
// import { PDFDocument } from 'pdf-lib';
import pdfjsLib from "pdfjs-dist/build/pdf";

pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.0.943/pdf.worker.min.js';

export default {
  name: "PdfUploadDialog",
  props: ['value', 'folderId'],
  data() {
    return {
      pdfName: null,
      pdf: null,
      pdf2Images: [],
      pdfPageNum: 0,
      doneLoading: false,
      pageName: null
    }
  },
  methods: {
    close() {
      this.$emit('input');
    },
    uploadPdf() {
      store.showLoadingOverlay(true);
      const form = new FormData();
      form.append('pageNum', this.pdfPageNum);
      this.pdf2Images.forEach((image, index) => {
        form.append('page_' + index + '_blob', image.image_blob);
        form.append('page_' + index + '_name', this.pageName);
      })
      this.axios
          .post('/api/report/pdf/' + this.folderId, form)
          .then((response) => {
            this.$emit('onUploadPdf', response.data.report_pdf_pages);
            this.close();
            store.showLoadingOverlay(false);
          })
    },
    readPDF(e) {
      if (!e.target.files || e.target.files.length === 0) return;
      this.pdfName = e.target.files[0].name;
      this.pageName = '不良モジュール診断詳細';
      const reader = new FileReader();
      reader.readAsArrayBuffer(e.target.files[0]);
      reader.onload = async (evt) => {
        const existingPdfBytes = evt.target.result;
        const pdf = await pdfjsLib.getDocument(existingPdfBytes);
        this.pdfPageNum = pdf.numPages;
        const images = new Array(this.pdfPageNum);
        let check = 0;
        for (let pageNumber = 1; pageNumber <= this.pdfPageNum; pageNumber++) {
          pdf.getPage(pageNumber).then(page => {
            const scale = 1.5;
            const viewport = page.getViewport(scale);

            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            const task = page.render({canvasContext: context, viewport: viewport})
            task.promise.then(() => {
              canvas.toBlob((blob) => {
                check = check + 1;
                images[pageNumber - 1] = {image_blob: blob, name: null};
                if (check === this.pdfPageNum) {
                  this.doneLoading = true;
                  this.pdf2Images = images;
                }
              });
            });
          });
        }
      }
    },
    addPDF() {
      this.pdfName = null;
      this.pdf = null;
      this.pdf2Images = [];
      this.pdfPageNum = 0;
      this.doneLoading = false;
      this.$refs.pdfUploader.click();
    },
  },
  mounted() {
    this.addPDF();
  },
  computed: {
    pdfPageName() {
      return this.pdf2Images.map(i => i.name);
    },
    uploadable() {
      return this.doneLoading && !!this.pageName;
    }
  }
}
</script>

<style scoped>

</style>
